import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { getStudentBooksLogsRequest } from "../../../../../../Backend/LogsRequests";
import { getStateName } from "../../../../../../Constants/BarcodeBookState";
import { getReportTypeName } from "../../../../../../Constants/ReportTypes";
import "./LogsModal.scss";
import {
  displayDateTime,
  parseDateFromUtc,
} from "../../../../../../Helpers/utils/utils";

export function LogsModal({ student, submit, ...props }) {
  const [t] = useTranslation();
  const [logs, setLogs] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    getStudentLogs();
  }, []);

  const getStudentLogs = async () => {
    const resp = await getStudentBooksLogsRequest(student.id);

    if (resp.success) {
      setLogs(resp.data);
    }
  };

  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    return `${dateTime.toLocaleDateString()} ${dateTime.toLocaleTimeString()}`;
  };

  const toggleGroup = (groupKey) => {
    setExpandedGroups((prevExpandedGroups) => ({
      [groupKey]: !prevExpandedGroups[groupKey],
    }));
  };

  const groupedData = logs.reduce((groups, item) => {
    const dateTime = new Date(item.date);
    const key = `${dateTime.toLocaleDateString()} ${dateTime.getHours()}:${dateTime.getMinutes()}`;
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
    return groups;
  }, {});

  const displayItems = Object.keys(groupedData).map((key, index) => {
    const items = groupedData[key];
    const isExpanded = expandedGroups[key];

    return (
      <div className="data-group" key={index}>
        <div className="group-header" onClick={() => toggleGroup(key)}>
          {/* {t("Date")}: {formatDateTime(items[0].date)} */}
          {t("Date")}: {displayDateTime(parseDateFromUtc(items[0].date))}
          <span className="icon">
            {isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </span>
        </div>
        {isExpanded && (
          <div className="group-items">
            {items.map((item, itemIndex) => (
              <div className="data-item" key={itemIndex}>
                <div className="item-wrapper">
                  <div className="key">{t("Status")}:</div>
                  <div className="value">
                    <div className="status-wrapper">
                      <div className={`status ${getStateName(item.state)}`}>
                        {t(getStateName(item.state))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item-wrapper">
                  <div className="key">{t("Barcode")}:</div>
                  <div className="value">{item.barcode}</div>
                </div>
                <div className="item-wrapper">
                  <div className="key">{t("ISBN")}:</div>
                  <div className="value">{item.isbn}</div>
                </div>

                <div className="item-wrapper">
                  <div className="key">{t("ReportType")}:</div>
                  <div className="value">
                    {item.reportType
                      ? t(getReportTypeName(item.reportType))
                      : "-"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  });

  return (
    <Modal {...props} size="lg" centered dialogClassName="logs-modal">
      <Modal.Header className="logs-modal-header" closeButton>
        <div className="title">
          {student.firstName} {student.preposition} {student.lastName}
        </div>
      </Modal.Header>
      <Modal.Body className="logs-modal-content">
        {logs.length === 0 ? (
          <div className="subtitle">{t("StudentHasNoLogsYet")}</div>
        ) : (
          displayItems
        )}
      </Modal.Body>
    </Modal>
  );
}
